import axios from 'axios';
import { baseUrl } from '@/config';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';

/**
 * user API
 * @author Yang
 */
export default {
  /**
   * [getUserAccountList 사용자 정보 조회]
   * @author {Yang}
   */
  getUserAccountList() {
    return axios.get(`${baseUrl}/frame/user-info/get-user-account-info.do`);
  },
  /**
   * 공지사항 리스트 조회
   * @author kimjy
   * @param  {Object} params 검색조건/페이징 처리 관련
   * @return {Array}        공지사항 리스트
   */
  getNoticeList(params) {
    return axios.post(`${baseUrl}/frame/user-info/get-notice-list.do`, params);
  },
  /**
   * 공지사항 파일 다운로드
   * @author kimjy
   */
  downloadNoticeFile(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/frame/user-info/download-notice-file.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [updateUserAccountInfo 사용자 정보 업데이트]
   * @author {Yang}
   * @return {[type]} [description]
   */
  updateUserAccountInfo(params) {
    return axios.post(`${baseUrl}/frame/user-info/update-user-account-info.do`, params);
  },
  /**
   * [updateUserPasswordInfo 사용자 정보 비밀번호 업데이트]
   * @author {Yang}
   * @param  {[type]} params [description]
   */
  updateUserPasswordInfo(params) {
    return axios.post(`${baseUrl}/frame/user-info/update-user-password-info.do`, params);
  },
  /**
   * 공지사항 추가
   * @author kimjy
   * @param  {[type]} params [description]
   */
  addNotice(params) {
    return axios.post(`${baseUrl}/frame/user-info/add-notice.do`, params);
  },
  /**
   * 미확인 공지사항 카운트 조회
   * @author kimjy
   * @return {Integer} 미확인 공지사항 카운트
   */
  getUnreadNoticeCount() {
    return axios.get(`${baseUrl}/frame/user-info/get-unread-notice-count.do`);
  },
  /**
   * 공지사항 삭제
   * @author kimjy
   * @param  {Array} params 삭제할 공지사항 리스트
   */
  deleteNotice(params) {
    return axios.post(`${baseUrl}/frame/user-info/delete-notice.do`, params);
  },
  /**
   * 공지사항 읽음
   * @author kimjy
   * @param  {Object} params 읽음 처리할 공지사항
   * @return {Integer}        미확인 공지사항 카운트
   */
  readNotice(params) {
    return axios.post(`${baseUrl}/frame/user-info/read-notice.do`, params);
  },
  /**
   * [getLoginHistoryList 로그인 기록 출력]
   * @author {Yang}
   */
  getLoginHistoryList(params) {
    return axios.post(`${baseUrl}/frame/user-info/get-login-history-list.do`, params);
  },
  /**
   * [exportExcelLoginHistoryList 로그인 기록 엑셀 출력]
   * @author {Yang}
   */
  exportExcelLoginHistoryList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/frame/user-info/export-excel-login-history-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', key.toLowerCase().indexOf('datetime') > -1 ? new Date(value) : value);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [getMenuAccessHistoryList 메뉴 접근 기록 출력]
   * @author {Yang}
   */
  getMenuAccessHistoryList(params) {
    return axios.post(`${baseUrl}/frame/user-info/get-menu-access-history-list.do`, params);
  },
  /**
   * [exportExcelMenuAccessHistoryList 메뉴접근기록 엑셀출력]
   * @author {Yang}
   */
  exportExcelMenuAccessHistoryList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/frame/user-info/export-excel-menu-access-history-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', key.toLowerCase().indexOf('datetime') > -1 ? new Date(value) : value);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 공지사항수정
   * @author kimjy
   * @param  {Object} params
   */
  updateNotice(params) {
    return axios.post(`${baseUrl}/frame/user-info/update-notice.do`, params);
  },
  /**
   * 읽지않은 쪽지 수
   * @author kimjy
   */
  getUnreadMessageCount() {
    return axios.get(`${baseUrl}/frame/user-info/get-unread-message-count.do`);
  },
  /**
   * 받은 쪽지 리스트
   * @author kimjy
   * @param  {Object} params
   */
  getReceiveMessageList(params) {
    return axios.post(`${baseUrl}/frame/user-info/get-receive-message-list.do`, params);
  },
  /**
   * 보낸 쪽지 리스트
   * @author kimjy
   * @param  {Object} params
   */
  getSendMessageList(params) {
    return axios.post(`${baseUrl}/frame/user-info/get-send-message-list.do`, params);
  },
  /**
   * 쪽지 읽음 처리
   * @author kimjy
   * @param  {Object} params
   * @return {Integer} 읽지않은 메시지 카운트
   */
  readMessage(params) {
    return axios.post(`${baseUrl}/frame/user-info/read-message.do`, params);
  },
  /**
   * 쪽지 파일 다운로드
   * @author kimjy
   */
  downloadMessageFile(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/frame/user-info/download-message-file.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 쪽지 전송
   * @author kimjy
   */
  sendMessage(params) {
    return axios.post(`${baseUrl}/frame/user-info/send-message.do`, params);
  },
  /**
   * 받은 쪽지 삭제
   * @author kimjy
   */
  deleteReceiveMessage(params) {
    return axios.post(`${baseUrl}/frame/user-info/delete-receive-message.do`, params);
  },
  /**
   * 보낸 쪽지 삭제
   * @author kimjy
   */
  deleteSendMessage(params) {
    return axios.post(`${baseUrl}/frame/user-info/delete-send-message.do`, params);
  },
  /**
   * 알람방식 로드
   * @author kimjy
   */
  getRuleMgrAlarmType() {
    return axios.get(`${baseUrl}/frame/user-info/get-rule-mgr-alarm-type.do`);
  },
  /**
   * 요일별 알람설정 로드
   * @author kimjy
   */
  getMgrWeekdayTimeList() {
    return axios.get(`${baseUrl}/frame/user-info/get-mgr-weekday-time-list.do`);
  },
  /**
   * 공휴일 알람설정 로드
   * @author kimjy
   */
  getMgrDateTimeList() {
    return axios.get(`${baseUrl}/frame/user-info/get-mgr-date-time-list.do`);
  },
  /**
   * 알람 시간 설정 : 요일별 정책 설정 복원
   * @author kimjy
   */
  rejectRuleDayTime() {
    return axios.get(`${baseUrl}/frame/user-info/reject-rule-day-time.do`);
  },
  /**
   * 알람 시간 설정 : 날짜별 정책 설정 복원
   * @author kimjy
   */
  rejectRuleDateTime() {
    return axios.get(`${baseUrl}/frame/user-info/reject-rule-date-time.do`);
  },
  /**
   * 변경된 알람 정책 설정
   * @author kimjy
   */
  updateRuleMgr(params) {
    return axios.post(`${baseUrl}/frame/user-info/update-rule-mgr.do`, params);
  },
  insertMenuHist(managetypeId, menuId) {
    return axios.post(`${baseUrl}/frame/insert-menu-hist.do`, { managetypeId, menuId });
  },
  /**
   * [프레임 > 비밀번호 변경 권고 팝업] 비밀번호 변경일을 N일 뒤로 연기한다.
   * (비밀번호 변경 날짜를 오늘로 업데이트한다.)
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updatePasswordChangedDate(params) {
    return axios.post(`${baseUrl}/frame/user-info/update-password-changed-date.do`, params);
  },
  /**
   * 알람 제한 정보를 조회한다.
   * @author na
   */
  getAlarmLockInfo() {
    return axios.get(`${baseUrl}/frame/user-info/get-alarm-lock-info.do`);
  },
  /**
   * 알람 잠금 해제를 위해 table_seq 테이블 데이터를 변경한다
   * @author na
   */
  resetAlarmLockCount() {
    return axios.get(`${baseUrl}/frame/user-info/reset-alarm-lock-count.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/frame/user.js